import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    deliveryRateList: () => {
        return HTTP.get('/delivery_rate/index', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    changeStatusDeliveryRate: (id) => {
        return HTTP.post('/delivery_rate/status/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addDeliveryRate: (data) => {
        return HTTP.post('/delivery_rate/store',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editDeliveryRate: (id,data) => {
        return HTTP.post('/delivery_rate/update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deliveryRateDetail: (id) => {
        return HTTP.get('/delivery_rate/edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deleteDeliveryRate: (id) => {
        return HTTP.post('/delivery_rate/destroy/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}